import { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Hover lift + pointer affordance for clickable cards. */
  interactive?: boolean;
  padded?: boolean;
  children: ReactNode;
}

export function Card({ interactive, padded = true, className, children, ...rest }: CardProps) {
  return (
    <div
      className={twMerge(
        clsx(
          'bg-white rounded-card border border-legal-200 shadow-elevation-1',
          padded && 'p-5',
          interactive && 'card-lift cursor-pointer'
        ),
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
